import type { InputHTMLAttributes } from "react";
import { HintMark } from "./Tooltip";

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label?: string;
  /** Short explanation shown via an info mark beside the label. */
  tooltip?: string;
}

export function Checkbox({ label, tooltip, id, style, ...rest }: CheckboxProps) {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: "var(--space-1)" }}>
      <label
        htmlFor={id}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "var(--space-2)",
          fontSize: "var(--font-size-sm)",
          color: "var(--color-text)",
          cursor: "pointer",
        }}
      >
        <input
          id={id}
          type="checkbox"
          {...rest}
          style={{
            width: 18,
            height: 18,
            accentColor: "var(--color-primary)",
            ...style,
          }}
        />
        {label}
      </label>
      {tooltip ? <HintMark label={label ? `About ${label}` : "More about this"} text={tooltip} /> : null}
    </span>
  );
}
